import { useEffect } from 'react';

/**
 * Custom hook to handle modal-open class cleanup
 * Fixes issue where modal-open class remains on body element
 * causing scroll to be disabled even when no modal is visible
 */
export const useModalCleanup = () => {
  useEffect(() => {
    const cleanup = () => {
      // Always remove modal-open class and reset body styles on component mount
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };

    // Force cleanup on component mount
    cleanup();

    // Cleanup after a short delay to handle async operations
    const timeoutId = setTimeout(cleanup, 100);

    // Cleanup function for useEffect
    return () => {
      clearTimeout(timeoutId);
      cleanup();
    };
  }, []);

  // Return a manual cleanup function that can be called
  const modalCleanup = () => {
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    console.log('Manual modal cleanup executed');
  };

  return modalCleanup;
};